import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "section content-container" }
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "report-container island" }
const _hoisted_5 = { class: "report-container island" }
const _hoisted_6 = { class: "report-container island" }

import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import ProactiveTriggersTrendChart from '@/features/reports/components/usage/ProactiveTriggersTrendChart.vue';
import BillableConversationsTrendChart from '@/features/reports/components/usage/BillableConversationsTrendChart.vue';
import ChannelMessagesTrendChart from '@/features/reports/components/usage/ChannelMessagesTrendChart.vue';
import { usageReportsApi, UsageReportsData } from '@/features/reports/services/usageReportsApi';
import { DatePicker } from '@/features/reports/services';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UsageReports',
  setup(__props) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const selectedDateOption = computed(() => store.getters.selectedDateOption);

const setLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const chartData = ref<UsageReportsData>({
  proactiveTriggersTrendReport: {
    scale: {
      title: '',
      labels: [],
    },
    series: [],
  },
  billableConversationsTrendReport: {
    scale: {
      title: '',
      labels: [],
    },
    series: [],
  },
  channelMessagesTrendReport: {
    scale: {
      title: '',
      labels: [],
    },
    series: [],
  },
});

const loadingError = ref(false);
const loadedData = ref(false);

watch(
  selectedDateOption,
  async (filter, previous) => {
    if (filter && filter === previous) {
      return;
    }

    await loadData();
  },
  { immediate: true },
);

async function loadData() {
  if (!DatePicker.isValidMonthOption(selectedDateOption.value)) {
    return; // Invalid selection, will be corrected in the date filter and this will be called again
  }

  loadedData.value = false;
  loadingError.value = false;
  setLoading(true);
  try {
    chartData.value = await usageReportsApi.loadData(currentWorkspace.value.id, {
      startDate: selectedDateOption.value.getDateRange().start,
      endDate: selectedDateOption.value.getDateRange().end,
    });
    loadedData.value = true;
  } catch {
    loadingError.value = true;
  } finally {
    setLoading(false);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BillableConversationsTrendChart, {
            data: chartData.value.billableConversationsTrendReport,
            loadedData: loadedData.value,
            loadingError: loadingError.value
          }, null, 8, ["data", "loadedData", "loadingError"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(ProactiveTriggersTrendChart, {
            data: chartData.value.proactiveTriggersTrendReport,
            loadedData: loadedData.value,
            loadingError: loadingError.value
          }, null, 8, ["data", "loadedData", "loadingError"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(ChannelMessagesTrendChart, {
            data: chartData.value.channelMessagesTrendReport,
            loadedData: loadedData.value,
            loadingError: loadingError.value
          }, null, 8, ["data", "loadedData", "loadingError"])
        ])
      ])
    ])
  ]))
}
}

})